<div class="card-body mt-2">
    <div class="mb-4">
        <h4>General</h4>
        <mat-divider class="mb-2"></mat-divider>
        <div>Name: <span class="fw-bold">{{ customer.firstName }} {{ customer.lastName }}</span></div>
        <div>Email: <span class="fw-bold">{{ customer.email }}</span></div>
        <div>Phone: <span class="fw-bold">{{ customer.phone }}</span></div>
        <div *ngIf="customer.dateOfBirth">
            Date of Birth: <span class="fw-bold">{{ customer.dateOfBirth }}</span>
        </div>
    </div>

    <!-- Addresses -->
    <div class="mb-4" *ngIf="customer.addresses.length">
        <h4>Addresses</h4>
        <mat-divider class="mb-2"></mat-divider>
        <ng-container *ngFor="let address of customer.addresses; let i = index">
            <ng-container *ngIf="address.addressable_id === customer.id && address.addressable_type === 'App\\Models\\Customer'">
                <div class="mb-2">
                    <div>Address {{ i + 1 }}:</div>
                    <span class="me-5 fw-bold">
                        {{ address.street1 }}, {{ address.city }}, {{ address.state }}, {{ address.zip }}, {{ address.country }}
                    </span>
                    <span>{{ address.startDate }}</span>
                    <span *ngIf="!address.endDate"> - Present</span>
                    <span *ngIf="address.endDate"> - {{ address.endDate }}</span>
                </div>
            </ng-container>
        </ng-container>
    </div>

    <!-- Employment Histories -->
    <div class="mb-4" *ngIf="customer.employment_histories.length">
        <h4>Employment Histories</h4>
        <mat-divider class="mb-2"></mat-divider>
        <ng-container *ngFor="let history of customer.employment_histories; let j = index">
            <ng-container *ngIf="history.customer_id === customer.id">
                <div class="mb-2">
                    <div>
                        <div>Employment History {{ j + 1 }}:</div>
                        <span class="me-5 fw-bold">{{ history.name }} - {{ history.position }}</span>
                        <span>{{ history.startDate }}</span>
                        <span *ngIf="!history.endDate"> - Present</span>
                        <span *ngIf="history.endDate"> - {{ history.endDate }}</span>
                    </div>
                    <ng-container *ngFor="let address of sale.addresses">
                        <ng-container *ngIf="address.addressable_id === history.id && address.addressable_type === 'App\\Models\\EmploymentHistory'">
                            <div>
                                <span>
                                    {{ address.street1 }}, {{ address.city }}, {{ address.state }}, {{ address.zip }}, {{ address.country }}
                                </span>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
